__turbopack_context__.v({
  "className": "_5-Jlia_className",
  "variable": "_5-Jlia_variable",
});
